import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { setLoadingState } from '../redux/loadingSlice'

const useAppInitialization = () => {
  const dispatch = useDispatch()
  const { adminLogin } = useSelector(state => state.auth)
  const location = useLocation()

  const [firstLoad, setFirstLoad] = useState(true)

  const isLoggedIn = adminLogin

  useEffect(() => {
    dispatch(setLoadingState(true)) // Start loading when the location changes
    const timer = setTimeout(() => {
      dispatch(setLoadingState(false)) // Stop loading after 1 second
      if (firstLoad) {
        setFirstLoad(false)
      }
    }, 1000)

    return () => clearTimeout(timer) // Clear the timeout when the component unmounts
  }, [dispatch, location, firstLoad])

  return { isLoggedIn }
}

export default useAppInitialization
